import * as React from 'react';
import { useMutation, useQuery } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { useStockBalanceSearchParams } from 'hooks/store/stock-balance';
import { useScheduleReport } from 'hooks/api/reports';
import { PageHeaderWithFilters } from 'components/ui/page-header-with-filters';
import { DataTable } from 'components/ui/DataTable';

import { useColumns, useFetchStocks, usePageHeaderConfig } from './hooks';
import { FiltersForm } from './components';

export const ListStocks = () => {
  const { filters, updateFilters, updateStockTypes, clearState } =
    useStockBalanceSearchParams();
  const { fetchStocks } = useFetchStocks();
  const { scheduleReport } = useScheduleReport();
  const { checkboxesConfig } = usePageHeaderConfig();
  const columns = useColumns();
  const navigate = useNavigate();

  const stocksQuery = useQuery({
    queryKey: ['fetch-stocks', filters],
    queryFn: () => fetchStocks({ filters }),
  });

  const scheduleReportMutation = useMutation({
    mutationFn: scheduleReport,
    onSuccess: () => {
      toast('Relatório requisitado com sucesso');
      navigate('/relatorios/saldo-estoque');
    },
    onError: () => {
      toast.error('Erro ao requisitar relatório');
    }
  });

  const onRequestReport = React.useCallback((reportParams: Record<string, unknown>) => {
    scheduleReportMutation.mutate({
      type: 'stock-balance',
      params: reportParams,
    });
  }, [scheduleReportMutation]);

  return (
    <>
      <PageHeaderWithFilters
        checkboxesConfig={checkboxesConfig}
        className={'mb-6'}
      >
        <FiltersForm
          onSubmitFilters={updateFilters}
          onResetFilters={clearState}
          onStockTypesChange={updateStockTypes}
          onRequestReport={onRequestReport}
        />
      </PageHeaderWithFilters>
      <DataTable
        columns={columns}
        data={stocksQuery?.data ?? []}
        isLoading={stocksQuery.isLoading}
      />
    </>
  );
};
